export default __webpack_public_path__ + "static/trainingHeroSmall-1f0c1c6dc6e2c2958f100f6e74f7409f.png";